import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class GoogleMapsAutocompleteService {


    constructor() {}

    parseAddress(raw_address_components) {
        var address = {
            "street1"   : "",
            "street2"   : "",
            "city"      : "",
            "zip"       : "",
            "state"     : "",
            "country"   : ""
        }
    
        if(!raw_address_components) {
            return address
        }
    
        var address_components: any = {}
        raw_address_components.forEach(function(component) {
            component.types.forEach(function(component_type){
                if((component_type == "locality" || 
                    component_type == "sublocality" || 
                    component_type == "sublocality_level_1" || 
                    component_type == "sublocality_level_2" || 
                    component_type == "sublocality_level_3" || 
                    component_type == "sublocality_level_4") && 
                    component.long_name != "") {
                        address_components[component_type] = component.long_name
                } else if(component_type == "country" && component.long_name != "") {
                    address_components[component_type] = component.long_name
                }
                else {
                    address_components[component_type] = component.short_name
                }
            })
        })
    
        if(address_components.street_number != undefined
            && address_components.street_number != "") {
            address["street1"] =  address_components.street_number
        }
    
        if(address_components.route != undefined
            && address_components.route != "") {
            address["street1"] +=  " " + address_components.route
        }
        
        if(address_components.locality != undefined
            && address_components.locality != "") {
            address["city"] =  address_components.locality
        } else if(address_components.sublocality != undefined
            && address_components.sublocality != "") {
            address["city"] =  address_components.sublocality
        } else if(address_components.sublocality_level_1 != undefined
            && address_components.sublocality_level_1 != "") {
            address["city"] =  address_components.sublocality_level_1    
        } else if(address_components.sublocality_level_2 != undefined
            && address_components.sublocality_level_2 != "") {
            address["city"] =  address_components.sublocality_level_2
        } else if(address_components.sublocality_level_3 != undefined
            && address_components.sublocality_level_3 != "") {
            address["city"] =  address_components.sublocality_level_3
        } else if(address_components.sublocality_level_4 != undefined
            && address_components.sublocality_level_4 != "") {
            address["city"] =  address_components.sublocality_level_4
        }
    
        if(address_components.postal_code != undefined
            && address_components.postal_code != "") {
            address["zip"] = address_components.postal_code
        }
    
        if(address_components.administrative_area_level_1 != undefined
            && address_components.administrative_area_level_1 != "") {
            address["state"] = address_components.administrative_area_level_1
        }
    
        if(address_components.country != undefined
            && address_components.country != "") {
            address["country"] = address_components.country
        }
    
        return address
    }

    getAddressText(streetAddressObject) {
        var strAddress = ""
        if(streetAddressObject != undefined && streetAddressObject != null) {
            if(streetAddressObject.street1 != "" && streetAddressObject.street1 != undefined) {
                strAddress = `${streetAddressObject.street1}, `;

                if(streetAddressObject.unitNum != "" && streetAddressObject.unitNum != undefined) {
                    strAddress += `${streetAddressObject.unitNum}, `;
                }
            }
            if(streetAddressObject.city != "" && streetAddressObject.city != undefined) {
                strAddress += `${streetAddressObject.city}, `;
            }
            if(streetAddressObject.state != "" && streetAddressObject.state != undefined) {
                strAddress += `${streetAddressObject.state}`;
            }
            if(streetAddressObject.zip != "" && streetAddressObject.zip != undefined) {
                strAddress += `, ${streetAddressObject.zip}`;
            }
        }
        
        return strAddress;
    }
}